import { createSlice } from "@reduxjs/toolkit";

export const searchSlice = createSlice({
    name: 'search',
    initialState: {
        action: false
    },
    reducers: {
        setAction: (state) => {
            state.action = !state.action;
        }
    }
})

export const { setAction } = searchSlice.actions;
export default searchSlice.reducer;
